import React from "react";
import { useConfiguration } from "../../hooks";
import { LoadingSpinner } from "./LoadingSpinner";
import { useChatState } from "../state/ChatState";
import { DigitalFriendWS } from "./Websocket/DigitalFriendWS";
import { DigitalFriend } from "./DigitalFriend";
import { DigitalFriendChatWS } from "./Websocket/DigitalFriendChatWS";
import { Toaster } from "react-hot-toast";
import { IFrameLayout } from "../IFrameLayout";

export const ConfigurationWrapper = () => {
	const { configurationLoading } = useConfiguration();
	const chatState = useChatState();

	const queryParams = new URLSearchParams(window.location.search);
	const isIFrame = queryParams.get("iframe") === "true";

	if (configurationLoading) {
		return (
			<div className="min-w-full min-h-screen flex items-center justify-center">
				<LoadingSpinner />
			</div>
		);
	}

	if (isIFrame) {
		return (
			<>
				<IFrameLayout />
				<Toaster />
			</>
		);
	}

	if (chatState?.baseConfig?.USE_WEBSOCKET === "true") {
		if (chatState?.baseConfig?.IS_VOICE_CHAT === "true") {
			return (
				<>
					<DigitalFriendWS />
					<Toaster />
				</>
			);
		}

		return (
			<>
				<DigitalFriendChatWS />
				<Toaster />
			</>
		);
	}

	return <DigitalFriend />;
};
